import { useContext, useEffect, useRef, useState } from 'react';

import { Image, Link, resetEditorChromes } from '@sitecore-jss/sitecore-jss-nextjs';

import { RcnUserContext } from 'src/context/RcnUser/RcnUserContext';

import { ComponentProps } from 'lib/ComponentProps';

import IsRcniLearningRoute from 'src/utils/isRcniLearningRoute';

import SearchBar from 'src/components/search/SearchBar/SearchBar';

import { AccessLevelMenus } from './_AccessLevelHeaderContent/_AccessLevelMenus';
import MultiLevelMenu from './_MultiTierMenu/_MultiTierMenu';

import { HeaderFields } from './HeaderFields';
import { NavigationMenu } from './NavigationMenu';

import styles from './Header.module.css';

type HeaderProps = ComponentProps & {
	fields: HeaderFields & {
		NavigationMenu: NavigationMenu;
	};
};

export default function Header(props: HeaderProps): JSX.Element {
	const [showSubMenu, setShowSubMenu] = useState(false);
	const dropdown = useRef(null);
	const RcnUser = useContext(RcnUserContext);
	const isRcniLearningRoute = IsRcniLearningRoute();

	useEffect(() => {
		resetEditorChromes();
	}, []);

	useEffect(() => {
		// only add the event listener when the dropdown is opened
		if (!showSubMenu) {
			return;
		}
		const handleClick = () => {
			if (dropdown.current) {
				setShowSubMenu(false);
			}
		};
		window.addEventListener('click', handleClick);
		// clean up
		return () => window.removeEventListener('click', handleClick);
	}, [showSubMenu]);

	if (!props.fields) {
		return <></>;
	}

	return (
		<section className={styles.section}>
			<div className={`${styles.header} maxWidth`}>
				<div className={styles.headerContainer}>
					<div className={styles.headerWrapper}>
						<Link field={props.fields.SiteLogoLink} className={styles.logoLink}>
							<Image
								field={isRcniLearningRoute ? props.fields.RcniLearningLogo : props.fields.SiteLogo}
								className={styles.logo}
								loading="lazy"
								height={64}
								width={270}
							/>
						</Link>

						<AccessLevelMenus {...props} />
					</div>
					<SearchBar {...props} integrated expandable buttonColour={RcnUser.authenticatedUserProfile ? 'pinkDark' : 'blueDark'} />
				</div>
			</div>
			<MultiLevelMenu NavigationMenu={props.fields.NavigationMenu} />
		</section>
	);
}
